import LikeAction from "./LikeAction";

export default LikeAction;
